import React, { FunctionComponent, SVGProps } from 'react';
import { useTheme } from 'styled-components';

export interface PreOrderAppleIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  isInvertedTheme?: boolean;
}

export const PreOrderAppleIcon: FunctionComponent<PreOrderAppleIconProps> = ({
  className,
  isInvertedTheme,
  ...props
}) => {
  const theme = useTheme();

  const getBGColor = () => {
    if (isInvertedTheme) {
      return theme.colors.differentBackground;
    }

    return theme.colors.primary;
  };

  const getLogoColor = () => {
    if (isInvertedTheme) {
      return theme.colors.primary;
    }

    return theme.colors.differentBackground;
  };

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className || ''}
      {...props}
    >
      <path
        fill={getBGColor()}
        d="M12,0h0c6.63,0,12,5.37,12,12h0c0,6.63-5.37,12-12,12h0C5.37,24,0,18.63,0,12H0C0,5.37,5.37,0,12,0Z"
      />
      <path
        fill={getLogoColor()}
        d="M15.74,10.41c-.06,.05-1.06,.62-1.06,1.91,0,1.48,1.28,2.01,1.32,2.02,0,.03-.2,.72-.68,1.42-.42,.62-.86,1.23-1.53,1.23s-.84-.4-1.61-.4-1.02,.41-1.63,.41-1.04-.57-1.53-1.27c-.57-.82-1.03-2.1-1.03-3.31,0-1.94,1.24-2.98,2.46-2.98,.65,0,1.19,.43,1.6,.43s.99-.46,1.73-.46c.28,0,1.29,.03,1.95,.99Zm-2.3-1.82c.31-.37,.52-.88,.52-1.39,0-.07,0-.14-.02-.2-.5,.02-1.09,.34-1.45,.76-.28,.32-.54,.84-.54,1.36,0,.08,.01,.16,.02,.18,.03,0,.08,.01,.13,.01,.45,0,1.01-.3,1.33-.71Z"
      />
    </svg>
  );
};

export default PreOrderAppleIcon;
